function KnownError(message) {
  this.name = 'KnownError';
  this.message = message;
  this.stack = (new Error()).stack;
}
KnownError.prototype = new Error();

export { KnownError };